import { Search } from 'lucide-react';
import { cn } from '@/lib/utils';

// Campo de búsqueda de los listados (UX-COMP-01): un solo markup y estilo para todas
// las pantallas. Nombre accesible propio (el placeholder no lo es, UX-A11Y-01).
type Props = {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  /** Nombre accesible; por defecto, el placeholder. */
  label?: string;
  className?: string;
};

export function SearchInput({ value, onChange, placeholder, label, className }: Props) {
  return (
    <div className={cn('relative', className)}>
      <Search
        aria-hidden="true"
        className="pointer-events-none absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
      />
      <input
        type="search"
        aria-label={label ?? placeholder}
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="min-h-[44px] w-full rounded-lg border border-border bg-background py-2 pl-9 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-primary focus:outline-none focus:ring-1 focus:ring-primary"
      />
    </div>
  );
}
